// @generated by protoc-gen-es v1.10.1
// @generated from file rbt/cloud/v1alpha1/logs/logs.proto (package rbt.cloud.v1alpha1.logs, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from enum rbt.cloud.v1alpha1.logs.Source
 */
export const Source = /*@__PURE__*/ proto3.makeEnum(
  "rbt.cloud.v1alpha1.logs.Source",
  [
    {no: 0, name: "UNSPECIFIED"},
    {no: 1, name: "SERVER"},
    {no: 2, name: "CONFIG_RUN"},
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.logs.LogRecord
 */
export const LogRecord = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.logs.LogRecord",
  () => [
    { no: 1, name: "uuid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "timestamp", kind: "message", T: Timestamp },
    { no: 3, name: "server_id", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "source" },
    { no: 5, name: "config_run_id", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "source" },
    { no: 6, name: "revision_number", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
    { no: 4, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.logs.ApplicationLogs
 */
export const ApplicationLogs = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.logs.ApplicationLogs",
  () => [
    { no: 2, name: "latest_revision", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.logs.EnsureRequest
 */
export const EnsureRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.logs.EnsureRequest",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.logs.EnsureResponse
 */
export const EnsureResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.logs.EnsureResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.logs.RegisterConsensusRequest
 */
export const RegisterConsensusRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.logs.RegisterConsensusRequest",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.logs.RegisterConsensusResponse
 */
export const RegisterConsensusResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.logs.RegisterConsensusResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.logs.RegisterRevisionRequest
 */
export const RegisterRevisionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.logs.RegisterRevisionRequest",
  () => [
    { no: 2, name: "revision_number", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.logs.RegisterRevisionResponse
 */
export const RegisterRevisionResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.logs.RegisterRevisionResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.logs.IngestRequest
 */
export const IngestRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.logs.IngestRequest",
  () => [
    { no: 1, name: "records", kind: "message", T: LogRecord, repeated: true },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.logs.IngestResponse
 */
export const IngestResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.logs.IngestResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.logs.LogsRequest
 */
export const LogsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.logs.LogsRequest",
  () => [
    { no: 3, name: "last", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 1, name: "follow", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "revisions", kind: "message", T: LogsRequest_RevisionFilter, repeated: true },
    { no: 2, name: "revision_numbers", kind: "scalar", T: 13 /* ScalarType.UINT32 */, repeated: true },
    { no: 4, name: "sources", kind: "enum", T: proto3.getEnumType(Source), repeated: true },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.logs.LogsRequest.RevisionFilter
 */
export const LogsRequest_RevisionFilter = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.logs.LogsRequest.RevisionFilter",
  () => [
    { no: 1, name: "operator", kind: "enum", T: proto3.getEnumType(LogsRequest_RevisionFilter_Operator) },
    { no: 2, name: "right_hand_revision_number", kind: "scalar", T: 13 /* ScalarType.UINT32 */, oneof: "right_hand" },
    { no: 3, name: "right_hand_latest", kind: "scalar", T: 8 /* ScalarType.BOOL */, oneof: "right_hand" },
  ],
  {localName: "LogsRequest_RevisionFilter"},
);

/**
 * @generated from enum rbt.cloud.v1alpha1.logs.LogsRequest.RevisionFilter.Operator
 */
export const LogsRequest_RevisionFilter_Operator = /*@__PURE__*/ proto3.makeEnum(
  "rbt.cloud.v1alpha1.logs.LogsRequest.RevisionFilter.Operator",
  [
    {no: 0, name: "EQUAL"},
    {no: 1, name: "GREATER_THAN_OR_EQUAL"},
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.logs.LogsResponse
 */
export const LogsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.logs.LogsResponse",
  () => [
    { no: 1, name: "records", kind: "message", T: LogRecord, repeated: true },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.logs.ArchiveRequest
 */
export const ArchiveRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.logs.ArchiveRequest",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.logs.ArchiveResponse
 */
export const ArchiveResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.logs.ArchiveResponse",
  [],
);

